import React from 'react';

import NumberFormatInput from './NumberFormatInput';

import './form.scss';

const PhoneInput = React.forwardRef((props, ref) => {
    return <NumberFormatInput ref={ref} type="tel" format="(###) ###-####" {...props} />;
});

export default PhoneInput;
